'use client';

import { GetBoundingBox, MapPoint } from './bboxUtils';
import { useCallback, useEffect, useState } from 'react';

type TMap = {
    latitude: string;
    longitude: string;
    address?: string;
};

export const Map = ({ latitude, longitude, address }: TMap) => {
    const [bbox, setBbox] = useState('');
    const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${latitude},${longitude}`;
    const haveCords = !!(latitude && longitude);

    const calcBbox = useCallback(() => {
        const mapPoint = new MapPoint(parseFloat(longitude), parseFloat(latitude));
        const bboxObject = GetBoundingBox(mapPoint, 2);
        const bboxArray = [
            bboxObject.minPoints.lat,
            bboxObject.minPoints.lng,
            bboxObject.maxPoints.lat,
            bboxObject.maxPoints.lng,
        ];

        setBbox(bboxArray.join(','));
        return bboxObject;
    }, [latitude, longitude]);

    useEffect(() => {
        calcBbox();

        return () => {
            setBbox('');
        };
    }, [calcBbox, latitude, longitude]);

    return (
        <>
            {address && <div className={'mb-5'}>{address}</div>}
            {haveCords && (
                <iframe
                    className={'h-[300px] w-full md:h-[325px] lg:h-[415px]'}
                    frameBorder="0"
                    scrolling="no"
                    marginHeight={0}
                    marginWidth={0}
                    src={src}
                    title="Location Map"
                />
            )}
        </>
    );
};
